export default {
    lang: {
        name: 'First played'
    }
}